export default __webpack_public_path__ + "f46ef91a0f7b4dbd3e004d2915e55baf.png";